import React, { useCallback } from "react"
import { AccountConfimationContainer, MessageContainer } from "./index.styled";
import SendEmailModal from "./components/send-email-modal";
import { Button, Text } from "../common";
import { useDispatch } from "react-redux";
import { fetchShowModal } from "../../store/auth/auth-actions";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";

interface AccountConfirmationProps {
    show: boolean;
}
const AccountConfirmation: React.FC<AccountConfirmationProps> = ({ show }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation('private-home-page', { keyPrefix: 'account-confirmation.bar' });

    const handleClick = useCallback(() => {
        dispatch(fetchShowModal(false));
    }, [dispatch]);

    return (
        <AccountConfimationContainer open={show}>
            <MessageContainer>
                <Text
                    fontSize={16}
                    fontWeight={700}
                >
                    {t('title')}
                </Text>
                <Button
                    backgroundColor="#fff"
                    textColor={theme.colors.primaryBlue.main}
                    padding="0.25rem 1rem"
                    onClick={handleClick}
                >
                    {t('button')}
                </Button>
            </MessageContainer>
            <SendEmailModal />
        </AccountConfimationContainer>
    )
};

export default AccountConfirmation;
